module.exports = __webpack_public_path__ + "assets/media/drift_login_foreground.8abf2537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drift_login_foreground.png
// module id = 547
// module chunks = 0